import React from 'react'
import './Menu.css'
import { NavLink } from 'react-router-dom'
import { ARTICLES, ASSET_MANAGEMENT ,ALLCATERGORIES,ESCALATION_RULE_LOG,EMAIL_EXECUTION ,ERROR_LOG, ALARM_PAGE , ADMIN_GROUP,MYPACK, TEAMPACK, COMPANY, DIVISION, REGION, MARKET, STORES, EMPLOYEES, ACQUISITION, DENSITY, STORECLASSIFICATION, COMPGROUP, CTYPE, EMPLOYEE_DEPARTMENT, EMPLOYEE_TYPE, EMPLOYEE_LEAVE_TYPE, JOB_TITLE, EMPLOYEE_STATUS, HIRE_STATUS, TERM_REASON, PART_FULL_TIME, HOURLY_SALARY, STOREHOURS, STORETRACKER, DENSITYTRACKER, COMMCOMPTRACKER, STORECLASSIFICATIONTRACKER, DESIGNATION_TRACKER, EMP_TYPE_HIRE_STATUS_TRACKER, ROLES, GROUPS, MODULEMETADATA, ROLE_MODULE_MAPPING, EMPLOYEE_ROLE_MAPPING, ODOO_STORE_TRANSFER_TRACKERS, ODOO_DESIGNATION_TRACKERS, KEY_TAG, STORETABLES, EMPLOYEETABLES, FORM_BULK_IMPORT, CHATGROUPS, DEFAULTGROUPS, TICKET, CATEGORIES, TICKETING, ESCALATION_RULES, QUESTIONLIST, MESSAGE_TEMPLATES_LIST, SEAT_BOOKING, EMAIL_RULE,EMAIL_RULE_LIST } from '../../shared/constants/Constants';
import MenuCollapsableItem from './MenuCollapsableItem'
import { Col } from 'react-bootstrap';
import Permissions from '../../shared/components/Permissions';
import ChatGroups from '../chat/components/ChatGroups';
import DefaultGroups from '../chat/components/DefaultGroups';

function isMenuActive({ isActive }) {
    return isActive ? 'menu-active' : '';
}

const Menu = ({ toggled, toggleMenu }) => {

    let logoPath = "/logo.png";
    let logopathcol = "/mark-dark.png";
    //let logoPath = "https://wirelessvision.com/wp-content/uploads/2019/05/logo.png";

    let empInfo = JSON.parse(localStorage.getItem('employee'));
    let emp_company = localStorage.getItem('emp_company');
    let securityTab = false;
    if (empInfo?.role === "admin") {
        securityTab = true;
    }

    let emp_no = JSON.parse(localStorage.getItem("emp_no"));
    let module_name = "VMO";
    let vmoPermission = Permissions(emp_no, module_name);
    let BIPermission = Permissions(emp_no, 'Power BI Security');
    let chatAuditPermission = Permissions(emp_no, 'Chat Audit');
    console.log("per::", BIPermission);
    let NotificationPermission = Permissions(emp_no, 'Notification Audit');
    const isAdmin = empInfo?.role === "admin";
    const ticketemployees = ["134321","105729"];
    const hasTicketAccess =  isAdmin || ticketemployees.includes(String(emp_no));
    const seatReservation = Permissions(emp_no, 'Seat Reservation');
    const AdminGroupPermission = Permissions(emp_no, 'Admin Group');
    return (
        <div className={"sidebar-wrapper " + (toggled ? "d-none" : "")}>
           <div className="sidebar-header">
                <Col xs={4} className="gx-0">
                    <img src={logoPath} alt="logo icon" className='company-logo' />
                </Col>
                {/* <Col className="gx-0">
                    <h4 className="logo-text">Operis</h4>
                </Col> */}
                <Col xs={1} className="toggle-menu float-end d-block d-md-none" onClick={toggleMenu}>
                    <i className='fa fa-bars'></i>
                </Col>
            </div>
            <div id="menu-spacer" style={{ height: '45px' }}></div>
            <div className="sidebar-body">
                <ul className="metismenu" id="menu">
                    {(emp_company === "Operis") ? (<>
                        <li>
                            <NavLink to={'/seatbooking'}>
                                <div className="parent-icon"><i className='fas fa-couch'></i>
                                </div>
                                <div className="menu-title">{SEAT_BOOKING}</div>
                            </NavLink>
                        </li>
                    </>) : (empInfo?.role === "hc_sales") ? (<>
                        <li>
                            <NavLink to={'/userProfile'}>
                                <div className="parent-icon"><i className='fa fa-user-o'></i>
                                </div>
                                <div className="menu-title">Profile</div>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={'/t-shirtSize'}>
                                <div className="parent-icon"><i className='fa fa-circle-info'></i>
                                </div>
                                <div className="menu-title">Additional Info</div>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={'/myplan?filter=none'}>
                                <div className="parent-icon"><i className='fa fa-tasks'></i>
                                </div>
                                <div className="menu-title">{MYPACK}</div>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={'/teamplan?filter=none'}>
                                <div className="parent-icon"><i className='fa fa-group'></i>
                                </div>
                                <div className="menu-title">{TEAMPACK}</div>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={'/defaultgroups?filter=none'}>
                                <div className="parent-icon"><i className='fa fa-comment'></i>
                                </div>
                                <div className="menu-title">{DEFAULTGROUPS}</div>
                            </NavLink>
                        </li>
                        {seatReservation?.create_permission ? (
                        <li>
                            <NavLink to={'/seatbooking'}>
                                <div className="parent-icon"><i className='fas fa-couch'></i>
                                </div>
                                <div className="menu-title">{SEAT_BOOKING}</div>
                            </NavLink>                            
                        </li>   
                         ) : (<></>)}    
                    </>): (
                    <>
                        <li>
                            <NavLink to={'/dashboard?filter=none'}>
                                <div className="parent-icon"><i className='fa fa-home'></i>
                                </div>
                                <div className="menu-title">Dashboard</div>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to={'/seatbooking'}>
                                <div className="parent-icon"><i className='fas fa-couch'></i>
                                </div>
                                <div className="menu-title">{SEAT_BOOKING}</div>
                            </NavLink>
                        </li>  
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fas fa-headset"></i>
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Vision Hub</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/ticketing?filter=none'} className={isMenuActive}><i className="fa fa-newspaper-o me-2"></i>Ticket List</NavLink>
                                </li>,
                                <li> <NavLink to={'/messageTemplatesList?filter=none'} className={isMenuActive}><i className="fa fa-envelope-open-text me-2"></i>Message Templates</NavLink>
                                </li>,
                                <li> <NavLink to={'/articles?filter=none'} className={isMenuActive}><i className="fa fa-newspaper-o me-2"></i>{ARTICLES}</NavLink>
                                </li>,
                                hasTicketAccess ? (
                                    <MenuCollapsableItem hasLeftArrow={true} className="padding-left-12"
                                        parent={[
                                            <div className="sub-menu-title me-3">Settings</div>
                                        ]}
                                        children={[ 
                                               
                                            <li> <NavLink to={'/allcategories?filter=none'} className={isMenuActive}><i className="fa fa-list me-2"></i>{ALLCATERGORIES}</NavLink>
                                            </li>,
                                            <li> <NavLink to={'/categories?filter=none'} className={isMenuActive}><i className="fa fa-sliders me-2"></i>Category Configs</NavLink>
                                            </li>,
                                            <li> <NavLink to={'/escalationRules?filter=none'} className={isMenuActive}><i className="fa fa-exclamation-triangle me-2"></i>{ESCALATION_RULES}</NavLink>
                                            </li>,  
                                            <li> <NavLink to={'/questionlist?filter=none'} className={isMenuActive}><i className="fa fa-question-circle me-2"></i>{QUESTIONLIST}</NavLink>
                                            </li>, 
                                            <li> <NavLink to={'/emailrulelist?filter=none'} className={isMenuActive}><i className="fa fa-envelope me-2"></i>{EMAIL_RULE_LIST}</NavLink>
                                            </li>,                
                                            <li> <NavLink to={'/ticket-email-execution?filter=none'} className={isMenuActive}><i className="fa fa-paper-plane me-2"></i>{EMAIL_EXECUTION}</NavLink>
                                            </li>, 
                                            <li> <NavLink to={'/ticket-escalationrule-log?filter=none'} className={isMenuActive}><i className="fa fa-history me-2"></i>{ESCALATION_RULE_LOG}</NavLink>
                                            </li>,                                                                                          
                                        ]}
                                    />
                                ) : (<></>)
                            ]}
                        />
                        
                        {/* <MenuCollapsableItem  hasRightArrow={false} // no arrow since there are no children
                                parent={[
                                    <div
                                    className="parent-icon"
                                    onClick={() => window.open("/tickets", "_self")}
                                    style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                    >
                                    <i className="fa fa-ticket"></i>
                                    <div style={{ marginLeft: "10px" }} className="menu-title">
                                        Ticketing System
                                    </div>
                                    </div>
                                ]}
                                /> */}

                        
                        {/* <li>
                            <NavLink to={'/ticketing?filter=none'}>
                                <div className="parent-icon"><i className='fas fa-ticket'></i>
                                </div>
                                <div className="menu-title">{TICKETING}</div>
                            </NavLink>
                        </li>

                        <li>
                            <NavLink to={'/messageTemplatesList?filter=none'}> 
                                <div className="parent-icon"><i className='fas fa-envelope-open-text'></i>
                                </div>
                                <div className="menu-title">{MESSAGE_TEMPLATES_LIST}</div>                             
                             </NavLink>                            
                        </li>                      */}
                        {/* {hasTicketAccess ? (
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fas fa-gear"></i>
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Vision Hub Settings</div>
                            ]}
                            children={[    
                                // <li> <NavLink to={'/?filter=none'} className={isMenuActive}>{TICKET}</NavLink>
                                // </li>,
                                <li> <NavLink to={'/categories?filter=none'} className={isMenuActive}>{CATEGORIES}</NavLink>
                                </li>,
                                <li> <NavLink to={'/escalationRules?filter=none'} className={isMenuActive}>{ESCALATION_RULES}</NavLink>
                                </li>,  
                                <li> <NavLink to={'/questionlist?filter=none'} className={isMenuActive}>{QUESTIONLIST}</NavLink>
                                </li>,                                                                                                                    
                            ]}
                        />
                         ) : (<></>)} */}                      
                         
                        
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fa fa-map"></i></div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Org. Hierarchy</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/company?filter=none'} className={isMenuActive}><i className="fa fa-building me-2"></i>{COMPANY}</NavLink></li>,
                                <li> <NavLink to={'/division?status=active'} className={isMenuActive}><i className="fa fa-sitemap me-2"></i>{DIVISION}</NavLink></li>,
                                <li> <NavLink to={'/region?status=active'} className={isMenuActive}><i className="fa fa-globe me-2"></i>{REGION}</NavLink></li>,
                                <li> <NavLink to={'/district?filter=none'} className={isMenuActive}><i className="fa fa-map-marker me-2"></i>{MARKET}</NavLink></li>,
                                <li> <NavLink to={'/stores?filter=none'} className={isMenuActive}><i className="fa fa-store me-2"></i>{STORES}</NavLink></li>,
                                <MenuCollapsableItem hasLeftArrow={true} className="padding-left-12"
                                    parent={[
                                        <div className="sub-menu-title me-3">{STORETABLES}</div>
                                    ]}
                                    children={[
                                        <li><NavLink to={'/channel-type?filter=none'} className={isMenuActive}><i className="fa fa-random me-2"></i>{CTYPE}</NavLink></li>,
                                        <li> <NavLink to={'/store-classification?filter=none'} className={isMenuActive}><i className="fa fa-tags me-2"></i>{STORECLASSIFICATION}</NavLink></li>,
                                        <li> <NavLink to={'/density?filter=none'} className={isMenuActive}><i className="fa fa-th me-2"></i>{DENSITY}</NavLink></li>,
                                        <li> <NavLink to={'/acquisition?filter=none'} className={isMenuActive}><i className="fa fa-handshake me-2"></i>{ACQUISITION}</NavLink></li>,
                                        <li><NavLink to={'/store-hours?filter=none'}><i className="fa fa-clock me-2"></i>{STOREHOURS}</NavLink></li>,
                                        <li> <NavLink to={'/commission-comp-group?filter=none'} className={isMenuActive}><i className="fa fa-percent me-2"></i>{COMPGROUP}</NavLink></li>,
                                    ]}
                                />
                            ]}
                        />
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fa fa-users"></i></div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Employees</div>
                            ]}
                            children={[ 
                                <li> <NavLink to={'/employees?filter=none'} className={isMenuActive}><i className="fa fa-user me-2"></i>{EMPLOYEES}</NavLink></li>,
                                <li> <NavLink to={'/all-tshirtsizes?filter=none'} className={isMenuActive}><i className="fa fa-id-card me-2"></i>Employee Additional Info</NavLink></li>,
                                (isAdmin || AdminGroupPermission.create_permission) ? (
                                    <li> <NavLink to={'/admingroup?filter=none'} className={isMenuActive}><i className="fa fa-users-cog me-2"></i>{ADMIN_GROUP}</NavLink></li>
                                ) : <></>,
                                securityTab ? (
                                <MenuCollapsableItem hasLeftArrow={true} className="padding-left-12"
                                    parent={[
                                        <div className="sub-menu-title me-3">{EMPLOYEETABLES}</div>
                                    ]}
                                    children={[
                                        <li> <NavLink to={'/departments?filter=none'} className={isMenuActive}><i className="fa fa-building me-2"></i>{EMPLOYEE_DEPARTMENT}</NavLink></li>,
                                        <li> <NavLink to={'/employee-types?filter=none'} className={isMenuActive}><i className="fa fa-user-tag me-2"></i>{EMPLOYEE_TYPE}</NavLink></li>,
                                        <li> <NavLink to={'/leave-types?filter=none'} className={isMenuActive}><i className="fa fa-plane me-2"></i>{EMPLOYEE_LEAVE_TYPE}</NavLink></li>,
                                        <li> <NavLink to={'/jobtitles?filter=none'} className={isMenuActive}><i className="fa fa-briefcase me-2"></i>{JOB_TITLE}</NavLink></li>,
                                        <li> <NavLink to={'/employee-status?filter=none'} className={isMenuActive}><i className="fa fa-toggle-on me-2"></i>{EMPLOYEE_STATUS}</NavLink></li>,
                                        <li> <NavLink to={'/hire-status?filter=none'} className={isMenuActive}><i className="fa fa-user-plus me-2"></i>{HIRE_STATUS}</NavLink></li>,
                                        <li> <NavLink to={'/term-reason?filter=none'} className={isMenuActive}><i className="fa fa-user-times me-2"></i>{TERM_REASON}</NavLink></li>,
                                        <li> <NavLink to={'/full-part-time?filter=none'} className={isMenuActive}><i className="fa fa-clock me-2"></i>{PART_FULL_TIME}</NavLink></li>,
                                        <li> <NavLink to={'/hourly-salary?filter=none'} className={isMenuActive}><i className="fa fa-money-bill me-2"></i>{HOURLY_SALARY}</NavLink></li>,
                                    ]}
                                />) : <></>,
                            ]}
                            
                        />     
                        <li>
                            <NavLink to={'/alarmpage?status=pending?filter={"status":{"filterType":"text","type":"inArray","filter":["pending"]}}'}>
                                <div className="parent-icon"><i className='fa fa-bullhorn'></i>
                                </div>
                                <div className="menu-title">{ALARM_PAGE}</div>
                            </NavLink>
                        </li> 

                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className='fa fa-cube'></i></div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">{ASSET_MANAGEMENT}</div>
                            ]}
                            children={[
                                <li><NavLink to={'/asset-management'} className={isMenuActive}><i className="fa fa-cube me-2"></i>Asset Management</NavLink></li>,
                                <li><NavLink to={'/asset-management-form'} className={isMenuActive}><i className="fa fa-file-alt me-2"></i>Asset FormList</NavLink></li>,
                            ]}
                        />

                        {securityTab ? (
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fas fa-shield"></i>
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Security</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/roles?filter=none'} className={isMenuActive}>{ROLES}</NavLink>
                                </li>,
                                <li> <NavLink to={'/groups?filter=none'} className={isMenuActive}>{GROUPS}</NavLink>
                                </li>,
                                <li> <NavLink to={'/module-meta-data?filter=none'} className={isMenuActive}>{MODULEMETADATA}</NavLink>
                                </li>,
                                <li> <NavLink to={'/role-module-mapping?filter=none'} className={isMenuActive}>{ROLE_MODULE_MAPPING}</NavLink>
                                </li>,
                                <li> <NavLink to={'/employee-role-mapping?filter=none'} className={isMenuActive}>{EMPLOYEE_ROLE_MAPPING}</NavLink>
                                </li>,                                
                            ]}
                        />
                        ) : (<></>)}

                        {/* {securityTab ? ( */}
                        {/* <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fas fa-dot-circle"></i>
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Odoo</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/odoo-store-transfer-trackers?filter=none'} className={isMenuActive}>{ODOO_STORE_TRANSFER_TRACKERS}</NavLink>
                                </li>,
                                <li> <NavLink to={'/odoo-designation-trackers?filter=none'} className={isMenuActive}>{ODOO_DESIGNATION_TRACKERS}</NavLink>
                                </li>,
                            ]}
                        /> */}
                        {/* ) : (<></>)} */}

                        {securityTab ? (
                        
                        <li>
                            <NavLink to={'/admin-key-tag?filter=none'}>
                                <div className="parent-icon"><i className='fas fa-tags'></i>
                                </div>
                                <div className="menu-title">{KEY_TAG}</div>
                            </NavLink>
                        </li>
                        ) : (<></>)}  
                        {/* <li>
                            <NavLink to={'/admin-key-tag?filter=none'}>
                                <div className="parent-icon"><i className='fas fa-tags'></i>
                                </div>
                                <div className="menu-title">{FORM_BULK_IMPORT}</div>
                            </NavLink>
                        </li> */}
                                       
                        {securityTab ? (
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fa fa-history"></i>  
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Trackers</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/region-tracker?filter=none'} className={isMenuActive}>Region Tracker</NavLink>
                                </li>,
                                <li> <NavLink to={'/district-tracker?filter=none'} className={isMenuActive}>District Tracker</NavLink>
                                </li>,
                                <li> <NavLink to={'/store-tracker?filter=none'} className={isMenuActive}>{STORETRACKER}</NavLink>
                                </li>,
                                <li> <NavLink to={'/densityclass-tracker?filter=none'} className={isMenuActive}>{DENSITYTRACKER}</NavLink>
                                </li>,
                                <li> <NavLink to={'/commcomp-tracker?filter=none'} className={isMenuActive}>{COMMCOMPTRACKER}</NavLink>
                                </li>,
                                <li> <NavLink to={'/store-classification-tracker?filter=none'} className={isMenuActive}>{STORECLASSIFICATIONTRACKER}</NavLink>
                                </li>,
                                <li> <NavLink to={'/designation-tracker?filter=none'} className={isMenuActive}>{DESIGNATION_TRACKER}</NavLink>
                                </li>,
                                <li> <NavLink to={'/emptype-hirestatus-tracker?filter=none'} className={isMenuActive}>{EMP_TYPE_HIRE_STATUS_TRACKER}</NavLink>
                                </li>,

                            ]}
                        />
                          ) : (<></>)}
                        {/* } {securityTab ? ( */}
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fa fa-clipboard-list"></i>
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Audits</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/queue-table?filter=none'} className={isMenuActive}>Workflows Queue</NavLink>
                                </li>,
                                <li> <NavLink to={'/audit?filter=none'} className={isMenuActive}>Audit logs</NavLink>
                                </li>,
                                <li> <NavLink to={'/hireTermQueue?filter=none'} className={isMenuActive}>Hire Term Queue</NavLink> </li>,
                                <li> <NavLink to={'/ticketerrorlog?filter=none'} className={isMenuActive}>{ERROR_LOG}</NavLink> </li>,


                            ]}
                        />
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fa fa-shopping-cart"></i>
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Product</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/products'} className={isMenuActive}>Products</NavLink>
                                </li>,
                                <li> <NavLink to={'/product-tables?filter=none'} className={isMenuActive}>Product Tables</NavLink>
                                </li>,
                                // <MenuCollapsableItem hasLeftArrow={true} className="padding-left-12"
                                //     parent={[
                                //         <div className="sub-menu-title me-3">Product Tables</div>
                                //     ]}
                                //     children={[
                                //         <li> <NavLink to={'/product-type?filter=none'} className={isMenuActive}>Product Type</NavLink>
                                //         </li>,
                                //         <li> <NavLink to={'/accessories?filter=none'} className={isMenuActive}>Accessories</NavLink>
                                //         </li>,
                                //         <li> <NavLink to={'/account-type?filter=none'} className={isMenuActive}>Account Type</NavLink>
                                //         </li>,
                                //         <li> <NavLink to={'/category?filter=none'} className={isMenuActive}>Category</NavLink>
                                //         </li>,
                                //         <li> <NavLink to={'/category-product?filter=none'} className={isMenuActive}>Category Product</NavLink>
                                //         </li>,
                                //         <li> <NavLink to={'/line-type?filter=none'} className={isMenuActive}>Line Type</NavLink>
                                //         </li>,
                                //         <li> <NavLink to={'/relationship-type?filter=none'} className={isMenuActive}>Relationship Type</NavLink>
                                //         </li>,
                                //     ]}

                                // />,

                            ]}
                        />
                        {vmoPermission.write_permission ? (<>
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fa fa-pencil-square-o"></i>
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">VMO</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/quarterlyReview?filter=none'} className={isMenuActive}>Quaterly Review</NavLink>
                                </li>,
                                <li> <NavLink to={'/retail-foundation?filter=none'} className={isMenuActive}> Retail Foundation</NavLink>
                                </li>,
                            ]}
                        /></>) : (<></>)}
                         <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fa fa-comment"></i>
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Chat</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/chatgroups?filter=none'} className={isMenuActive}>Group</NavLink>
                                </li>,
                                <li> <NavLink to={'/defaultgroups?filter=none'} className={isMenuActive}>Broadcast Groups</NavLink>
                                </li>,
                                chatAuditPermission?.create_permission ? (
                                    <li>
                                        <NavLink to={'/auditmessages?filter=none'} className={isMenuActive}>Audit Messages</NavLink>
                                    </li>
                                ) : null,                               
                            ]}
                        />
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fa fa-comment"></i>
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Notification</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/notification?filter=none'} className={isMenuActive}>Notifications</NavLink>
                                </li>,
                                NotificationPermission?.create_permission ? (
                                <li> <NavLink to={'/notification/Audits?filter=none'} className={isMenuActive}>Audit Notifications</NavLink>
                                </li>
                                ) : null,                        
                            ]}
                        />
                        {/* <li>
                            <NavLink to={'/search-sap?filter=none'}>
                                <div className="parent-icon"><i className='fas fa-store'></i>
                                </div>
                                <div className="menu-title">Search SAP</div>
                            </NavLink>
                        </li> */}
                        <MenuCollapsableItem hasRightArrow={true}
                            parent={[
                                <div className="parent-icon"><i className="fa fa-store"></i>
                                </div>,
                                <div style={{ marginLeft: '10px' }} className="menu-title">Search SAP</div>
                            ]}
                            children={[
                                <li> <NavLink to={'/search-sap?filter=none'} className={isMenuActive}>Search SAP</NavLink></li>,                                
                                <li><NavLink to={'/storevisit?filter=none'} className={isMenuActive}>Store Visit List</NavLink></li>
                                                            
                            ]}
                        />
                         
                        <li>
                            <NavLink to={'/allplan?filter=none'}>
                                <div className="parent-icon"><i className='fa fa-file'></i>
                                </div>
                                <div className="menu-title">{"All Priority Plans"}</div>
                            </NavLink>
                        </li>
                        {BIPermission?.create_permission ? (
                        <li>
                            <NavLink to={'/powerbi-security'}>
                                <div className="parent-icon"><i className='fa fa-chart-bar'></i>
                                </div>
                                <div className="menu-title">{"Power BI Security"}</div>
                            </NavLink>
                        </li>
                        ) : (<></>)}
                        <></>
                    </>)}
                    {/* ) : (<></>)} */}
                </ul>
            </div>
        </div>
    )
}

export default Menu